export default {
  default: {
    addButton: 'Add User',
    lead: 'Lead',
    support: 'Support',
    title: 'Users',
    manage: 'Manage',
  },
}
